import { render, staticRenderFns } from "./ProfileList.vue?vue&type=template&id=120419d6&scoped=true"
import script from "./ProfileList.vue?vue&type=script&lang=js"
export * from "./ProfileList.vue?vue&type=script&lang=js"
import style0 from "./ProfileList.vue?vue&type=style&index=0&id=120419d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120419d6",
  null
  
)

export default component.exports